// src/pages/dashboard/admin/eventosAdmin.js
import React, { useEffect, useState } from "react";
import {
    Button,
    Modal,
    Form,
    Table,
    Alert,
    Row,
    Col,
    Card,
    InputGroup,
} from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";

export default function EventosAdmin() {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const token = localStorage.getItem("token") || sessionStorage.getItem("token");

    const [eventos, setEventos] = useState([]);
    const [praticantes, setPraticantes] = useState([]);
    const [eventoPraticantes, setEventoPraticantes] = useState([]);

    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState("");
    const [error, setError] = useState("");

    // modais
    const [showEventoModal, setShowEventoModal] = useState(false);
    const [editingEvento, setEditingEvento] = useState(null);
    const [eventoForm, setEventoForm] = useState({
        nome: "",
        descricao: "",
        localidade: "",
        data_inicio: "",
        data_fim: "",
        tipoEvento: "",
        hora_inicio: "",
        hora_fim: "",
    });

    const [showConvocarModal, setShowConvocarModal] = useState(false);
    const [convocarEvento, setConvocarEvento] = useState(null);
    const [convocarList, setConvocarList] = useState([]);
    const [convocarSearch, setConvocarSearch] = useState("");

    const [showConfirmarModal, setShowConfirmarModal] = useState(false);
    const [confirmarEvento, setConfirmarEvento] = useState(null);
    const [confirmarList, setConfirmarList] = useState([]);
    const [confirmarSearch, setConfirmarSearch] = useState("");

    const [search, setSearch] = useState("");
    const [orderDir, setOrderDir] = useState("asc"); // "asc" = mais antiga primeiro, "desc" = mais recente primeiro
    const [showPast, setShowPast] = useState(false);
    const [orderBy, setOrderBy] = useState("nome"); // <--- adicionar isto


    const authHeaders = () => ({ Authorization: `Bearer ${token}` });

    useEffect(() => {
        loadAll();
    }, []);

    const loadAll = async () => {
        setLoading(true);
        try {
            const [resE, resP, resEP] = await Promise.all([
                fetch(`${API_BASE_URL}/Eventos`, { headers: authHeaders() }),
                fetch(`${API_BASE_URL}/Praticantes`, { headers: authHeaders() }),
                fetch(`${API_BASE_URL}/EventoPraticantes`, { headers: authHeaders() }),
            ]);

            setEventos(resE.ok ? await resE.json() : []);
            const pr = resP.ok ? await resP.json() : [];
            setPraticantes(pr.filter((p) => p.isAtivo === 1 || p.isAtivo === true));
            setEventoPraticantes(resEP.ok ? await resEP.json() : []);
        } catch (err) {
            console.error(err);
            setError("Erro ao carregar dados.");
        } finally {
            setLoading(false);
        }
    };

    const GRADUACOES = [
        { value: 0, nome: "9º Kyu", className: "belt-white" },
        { value: 1, nome: "8º Kyu", className: "belt-yellow" },
        { value: 2, nome: "7º Kyu", className: "belt-orange" },
        { value: 3, nome: "6º Kyu", className: "belt-green" },
        { value: 4, nome: "5º Kyu", className: "belt-blue" },
        { value: 5, nome: "4º Kyu", className: "belt-red" },
        { value: 6, nome: "3º Kyu", className: "belt-brown" },
        { value: 7, nome: "2º Kyu", className: "belt-brown" },
        { value: 8, nome: "1º Kyu", className: "belt-brown" },
        ...Array.from({ length: 10 }, (_, i) => ({
            value: 9 + i,
            nome: `${i + 1}º Dan`,
            className: "belt-black",
        })),
    ];

    const getGraduacaoInfo = (value) =>
        GRADUACOES.find((g) => g.value === value);

    const calcularIdade = (dataNascimento) => {
        if (!dataNascimento) return null;
        const n = new Date(dataNascimento);
        if (isNaN(n)) return null;

        const hoje = new Date();
        let idade = hoje.getFullYear() - n.getFullYear();
        const m = hoje.getMonth() - n.getMonth();
        if (m < 0 || (m === 0 && hoje.getDate() < n.getDate())) idade--;
        return idade;
    };


    // -----------------------
    // Criar / editar / apagar evento
    // -----------------------
    const openCreateEvento = () => {
        setEventoForm({
            nome: "",
            descricao: "",
            localidade: "",
            data_inicio: "",
            data_fim: "",
            tipoEvento: "",
            hora_inicio: "",
            hora_fim: "",
        });
        setEditingEvento(null);
        setShowEventoModal(true);
    };

    const openEditEvento = (e) => {
        setEditingEvento(e);
        setEventoForm({
            nome: e.nome || "",
            descricao: e.descricao || "",
            localidade: e.localidade || "",
            tipoEvento: e.tipoEvento || "",
            data_inicio: e.data_inicio
                ? moment(e.data_inicio).format("YYYY-MM-DD")
                : "",
            data_fim: e.data_fim ? moment(e.data_fim).format("YYYY-MM-DD") : "",
            hora_inicio: e.hora_inicio || "",
            hora_fim: e.hora_fim || "",
        });
        setShowEventoModal(true);
    };

    const saveEvento = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");

        if (!eventoForm.nome || !eventoForm.data_inicio || !eventoForm.data_fim) {
            setError("Preenche todos os campos obrigatórios.");
            return;
        }

        const payload = {
            nome: eventoForm.nome,
            descricao: eventoForm.descricao,
            localidade: eventoForm.localidade,
            tipoEvento: eventoForm.tipoEvento,
            data_inicio: new Date(eventoForm.data_inicio).toISOString(),
            data_fim: new Date(eventoForm.data_fim).toISOString(),
            hora_inicio: eventoForm.hora_inicio + ":00",
            hora_fim: eventoForm.hora_fim + ":00",
        };

        try {
            const res = await fetch(
                `${API_BASE_URL}/Eventos${editingEvento ? `/${editingEvento.id}` : ""}`,
                {
                    method: editingEvento ? "PUT" : "POST",
                    headers: { "Content-Type": "application/json", ...authHeaders() },
                    body: JSON.stringify(payload),
                }
            );
            if (!res.ok) throw new Error(await res.text());
            setSuccess(editingEvento ? "Evento atualizado." : "Evento criado.");
            setShowEventoModal(false);
            await loadAll();
        } catch (err) {
            console.error(err);
            setError("Erro ao guardar evento.");
        }
    };

    const deleteEvento = async (ev) => {
        if (!window.confirm(
            `Deseja eliminar o evento "${ev.nome}"? Todas as associações de praticantes serão também eliminadas.`
        )) return;

        try {
            // 1. apagar todas as associações de EventoPraticante
            const associados = eventoPraticantes.filter(ep => ep.eventoId === ev.id);
            for (const assoc of associados) {
                await fetch(`${API_BASE_URL}/eventoPraticantes/${assoc.id}`, {
                    method: "DELETE",
                    headers: authHeaders(),
                });
            }

            // 2. apagar o evento
            const res = await fetch(`${API_BASE_URL}/eventos/${ev.id}`, {
                method: "DELETE",
                headers: authHeaders(),
            });
            if (!res.ok) throw new Error(await res.text());

            setSuccess("Evento eliminado.");
            await loadAll();
        } catch (err) {
            console.error(err);
            setError("Erro ao eliminar evento.");
        }
    };


    // -----------------------
    // Convocar praticantes
    // -----------------------
    const openConvocarModal = (ev) => {
        setConvocarEvento(ev);
        const associated = eventoPraticantes.filter((ep) => ep.eventoId === ev.id);
        const list = praticantes.map((p) => ({
            praticante: p,
            checked: !!associated.find((a) => a.praticanteId === p.id),
        }));
        setConvocarList(list);
        setShowConvocarModal(true);
    };

    const toggleConvocarCheck = (prId) => {
        setConvocarList((old) =>
            old.map((x) =>
                x.praticante.id === prId ? { ...x, checked: !x.checked } : x
            )
        );
    };

    const saveConvocar = async () => {
        if (!convocarEvento) return;
        setError("");
        setSuccess("");

        const existing = eventoPraticantes.filter(
            (ep) => ep.eventoId === convocarEvento.id
        );
        const toCreate = [];
        const toDelete = [];

        // Preparar lista para envio de SMS (apenas para os NOVOS convocados)
        const novosPraticantesParaSms = [];

        for (const item of convocarList) {
            const already = existing.find(
                (e) => e.praticanteId === item.praticante.id
            );

            if (item.checked && !already) {
                toCreate.push(item.praticante.id);
                // Guardamos os dados necessários para o SMS
                novosPraticantesParaSms.push({
                    praticanteId: item.praticante.id,
                    nome: String(item.praticante.nome),
                    telefone: String(item.praticante.telefone || "")
                });
            }
            if (!item.checked && already) toDelete.push(already.id);
        }

        try {
            // 1. Criar novas associações na Base de Dados
            for (const pratId of toCreate) {
                await fetch(`${API_BASE_URL}/EventoPraticantes`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json", ...authHeaders() },
                    body: JSON.stringify({
                        id: 0,
                        eventoId: convocarEvento.id,
                        praticanteId: pratId,
                        isConfirmado: 0,
                        isKata: 0,
                        isKumite: 0,
                        classificacaoKata: 0,
                        classificacaoKumite: 0,
                        dataLimiteConfirmacao: new Date().toISOString(),
                    }),
                });
            }

            // 2. Eliminar associações desmarcadas
            for (const assocId of toDelete) {
                await fetch(`${API_BASE_URL}/EventoPraticantes/${assocId}`, {
                    method: "DELETE",
                    headers: authHeaders(),
                });
            }

            // 3. ENVIAR SMS (Apenas se houver novos convocados)
            if (novosPraticantesParaSms.length > 0) {
                await fetch(`${API_BASE_URL}/Mensagens/convocar-evento`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json", ...authHeaders() },
                    body: JSON.stringify({
                        eventoId: Number(convocarEvento.id),
                        praticantes: novosPraticantesParaSms
                    }),
                });
            }

            setSuccess("Convocações e avisos SMS processados.");
            setShowConvocarModal(false);
            await loadAll();
        } catch (err) {
            console.error(err);
            setError("Erro ao atualizar convocações ou enviar mensagens.");
        }
    };

    // -----------------------
    // Confirmar presença
    // -----------------------
    const openConfirmarModal = (ev) => {
        setConfirmarEvento(ev);
        const associated = eventoPraticantes.filter((ep) => ep.eventoId === ev.id);
        const list = associated.map((a) => {
            const prat =
                praticantes.find((p) => p.id === a.praticanteId) || {
                    id: a.praticanteId,
                    nome: "N/A",
                };
            return {
                assocId: a.id,
                praticante: prat,
                isConfirmado: a.isConfirmado === 1 || a.isConfirmado === true,
            };
        });
        setConfirmarList(list);
        setShowConfirmarModal(true);
    };

    const toggleConfirmarCheck = (assocId) => {
        setConfirmarList((old) =>
            old.map((x) =>
                x.assocId === assocId ? { ...x, isConfirmado: !x.isConfirmado } : x
            )
        );
    };

    const saveConfirmar = async () => {
        try {
            for (const item of confirmarList) {
                const assoc = eventoPraticantes.find((ep) => ep.id === item.assocId);
                if (!assoc) continue;
                const newVal = item.isConfirmado ? 1 : 0;
                if ((assoc.isConfirmado === 1) !== item.isConfirmado) {
                    await fetch(`${API_BASE_URL}/EventoPraticantes/${assoc.id}`, {
                        method: "PUT",
                        headers: { "Content-Type": "application/json", ...authHeaders() },
                        body: JSON.stringify({ ...assoc, isConfirmado: newVal }),
                    });
                }
            }
            setSuccess("Confirmações atualizadas.");
            setShowConfirmarModal(false);
            await loadAll();
        } catch (err) {
            console.error(err);
            setError("Erro ao guardar confirmações.");
        }
    };

    const getCounts = (eventoId) => {
        const assoc = eventoPraticantes.filter((ep) => ep.eventoId === eventoId);
        const total = assoc.length;
        const confirmed = assoc.filter(
            (a) => a.isConfirmado === 1 || a.isConfirmado === true
        ).length;
        return { total, confirmed };
    };

    const convocarFiltered = convocarList.filter((x) =>
        x.praticante.nome.toLowerCase().includes(convocarSearch.toLowerCase())
    );
    const confirmarFiltered = confirmarList.filter((x) =>
        x.praticante.nome.toLowerCase().includes(confirmarSearch.toLowerCase())
    );

    const eventosProcessados = [...eventos]
        .filter(e => {
            const nomeMatch = e.nome?.toLowerCase().includes(search.toLowerCase());
            const isFuture = moment(e.data_fim).isSameOrAfter(moment());
            return nomeMatch && (showPast || isFuture);
        })
        .sort((a, b) => {
            if (orderBy === "nome") {
                const nA = a.nome?.toLowerCase() || "";
                const nB = b.nome?.toLowerCase() || "";
                if (nA < nB) return orderDir === "asc" ? -1 : 1;
                if (nA > nB) return orderDir === "asc" ? 1 : -1;
                return 0;
            }

            if (orderBy === "data_inicio") {
                const dateA = moment(a.data_inicio);
                const dateB = moment(b.data_inicio);
                return orderDir === "asc" ? dateA - dateB : dateB - dateA;
            }

            return 0;
        });

    return (
        <>
            <div className="d-flex justify-content-between flex-wrap gap-3 align-items-start py-4">
                <div>
                    <h1 className="h4 mb-1">Gestão de Eventos</h1>
                    <p className="mb-0 text-muted">Faça a gestão de eventos e convoque praticantes.</p>
                </div>
                <Button variant="primary" onClick={openCreateEvento}>
                    <FontAwesomeIcon icon={faPlus} className="me-2" /> Novo Evento
                </Button>
            </div>

            {error && <Alert variant="danger" onClose={() => setError("")} dismissible>{error}</Alert>}
            {success && <Alert variant="success" onClose={() => setSuccess("")} dismissible>{success}</Alert>}

            {/* Filtros */}
            <Row className="mb-3 g-2 align-items-center">
                <Col xs={12} sm={5}>
                    <Form.Control placeholder="Pesquisar por nome..." value={search} onChange={(e) => setSearch(e.target.value)} />
                </Col>
                <Col xs={6} sm={3}>
                    <Form.Select value={orderDir} onChange={e => setOrderDir(e.target.value)}>
                        <option value="asc">Data ↑</option>
                        <option value="desc">Data ↓</option>
                    </Form.Select>
                </Col>
                <Col xs={6} sm={4} className="d-flex align-items-center">
                    <Form.Check type="checkbox" label="Mostrar eventos passados" checked={showPast} onChange={() => setShowPast(!showPast)} />
                </Col>
            </Row>

            {/* Tabela — desktop */}
            <div className="d-none d-md-block">
                <Card className="shadow-sm mb-4">
                    <Card.Body className="p-0">
                        <Table responsive hover className="mb-0">
                            <thead className="thead-light">
                            <tr>
                                <th>Nome</th>
                                <th>Tipo</th>
                                <th>Localidade</th>
                                <th>Data</th>
                                <th>Confirmados / Total</th>
                                <th>Ações</th>
                            </tr>
                            </thead>
                            <tbody>
                            {eventosProcessados.map((e) => {
                                const counts = getCounts(e.id);
                                const isPast = moment(e.data_fim).isBefore(moment());
                                return (
                                    <tr key={e.id} className={isPast ? "opacity-75" : ""}>
                                        <td className="fw-bold">{e.nome}</td>
                                        <td>{e.tipoEvento}</td>
                                        <td>{e.localidade}</td>
                                        <td>{moment(e.data_inicio).format("DD/MM/YYYY")} — {moment(e.data_fim).format("DD/MM/YYYY")}</td>
                                        <td>
                                            <span className={`badge bg-${counts.confirmed === counts.total && counts.total > 0 ? "success" : "secondary"}`}>
                                                {counts.confirmed} / {counts.total}
                                            </span>
                                        </td>
                                        <td>
                                            <div className="d-flex flex-wrap gap-1">
                                                <Button size="sm" variant="outline-primary" onClick={() => openConvocarModal(e)}>Convocar</Button>
                                                <Button size="sm" variant="outline-success" onClick={() => openConfirmarModal(e)}>Confirmar</Button>
                                                <Button size="sm" variant="outline-secondary" onClick={() => openEditEvento(e)}><FontAwesomeIcon icon={faEdit} /></Button>
                                                <Button size="sm" variant="outline-danger" onClick={() => deleteEvento(e)}><FontAwesomeIcon icon={faTrash} /></Button>
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                            </tbody>
                        </Table>
                    </Card.Body>
                </Card>
            </div>

            {/* Cards — mobile */}
            <div className="d-md-none">
                {eventosProcessados.length === 0 ? (
                    <div style={{ textAlign: "center", padding: "48px 20px", background: "white", borderRadius: 16 }}>
                        <p className="text-muted mb-0 fw-bold">Nenhum evento encontrado.</p>
                    </div>
                ) : eventosProcessados.map((e) => {
                    const counts = getCounts(e.id);
                    const isPast = moment(e.data_fim).isBefore(moment());
                    return (
                        <div key={e.id} style={{ background: "white", borderRadius: 14, padding: 16, marginBottom: 10, boxShadow: "0 2px 8px rgba(0,0,0,0.07)", border: "1px solid #f0f0f5", opacity: isPast ? 0.7 : 1 }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
                                <div style={{ fontWeight: 700, fontSize: 15, color: "#1e1d45", flex: 1, marginRight: 8 }}>{e.nome}</div>
                                <span className="badge bg-secondary" style={{ fontSize: 10, flexShrink: 0 }}>{e.tipoEvento}</span>
                            </div>
                            <div style={{ fontSize: 13, color: "#6c757d", marginBottom: 4 }}>
                                📍 {e.localidade || "—"}
                            </div>
                            <div style={{ fontSize: 13, color: "#6c757d", marginBottom: 10 }}>
                                📅 {moment(e.data_inicio).format("DD/MM/YYYY")} — {moment(e.data_fim).format("DD/MM/YYYY")}
                            </div>
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", borderTop: "1px solid #f0f0f5", paddingTop: 10 }}>
                                <span className={`badge bg-${counts.confirmed === counts.total && counts.total > 0 ? "success" : "secondary"}`}>
                                    {counts.confirmed} / {counts.total} confirmados
                                </span>
                                <div className="d-flex gap-1">
                                    <Button size="sm" variant="outline-primary" onClick={() => openConvocarModal(e)}>Convocar</Button>
                                    <Button size="sm" variant="outline-success" onClick={() => openConfirmarModal(e)}>Confirmar</Button>
                                    <Button size="sm" variant="outline-secondary" onClick={() => openEditEvento(e)}><FontAwesomeIcon icon={faEdit} /></Button>
                                    <Button size="sm" variant="outline-danger" onClick={() => deleteEvento(e)}><FontAwesomeIcon icon={faTrash} /></Button>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
    {/* Modal Criar/Editar Evento */}
            <Modal
                show={showEventoModal}
                centered
                onHide={() => setShowEventoModal(false)}
            >
                <Modal.Header closeButton>
                    <Modal.Title>
                        {editingEvento ? "Editar Evento" : "Novo Evento"}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={saveEvento}>
                        <Form.Group className="mb-3">
                            <Form.Label>Nome</Form.Label>
                            <Form.Control
                                type="text"
                                value={eventoForm.nome}
                                onChange={(e) =>
                                    setEventoForm({ ...eventoForm, nome: e.target.value })
                                }
                                required
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Descrição</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={2}
                                value={eventoForm.descricao}
                                onChange={(e) =>
                                    setEventoForm({ ...eventoForm, descricao: e.target.value })
                                }
                            />
                        </Form.Group>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Localidade</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={eventoForm.localidade}
                                        onChange={(e) =>
                                            setEventoForm({
                                                ...eventoForm,
                                                localidade: e.target.value,
                                            })
                                        }
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Tipo de Evento</Form.Label>
                                    <Form.Control
                                        type="text"
                                        value={eventoForm.tipoEvento}
                                        onChange={(e) =>
                                            setEventoForm({
                                                ...eventoForm,
                                                tipoEvento: e.target.value,
                                            })
                                        }
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Data Início</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={eventoForm.data_inicio}
                                        onChange={(e) =>
                                            setEventoForm({
                                                ...eventoForm,
                                                data_inicio: e.target.value,
                                            })
                                        }
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Data Fim</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={eventoForm.data_fim}
                                        onChange={(e) =>
                                            setEventoForm({ ...eventoForm, data_fim: e.target.value })
                                        }
                                        required
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Hora Início</Form.Label>
                                    <Form.Control
                                        type="time"
                                        value={eventoForm.hora_inicio}
                                        onChange={(e) =>
                                            setEventoForm({ ...eventoForm, hora_inicio: e.target.value })
                                        }
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Hora Fim</Form.Label>
                                    <Form.Control
                                        type="time"
                                        value={eventoForm.hora_fim}
                                        onChange={(e) =>
                                            setEventoForm({ ...eventoForm, hora_fim: e.target.value })
                                        }
                                        required
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <div className="d-flex justify-content-end">
                            <Button
                                variant="secondary"
                                className="me-2"
                                onClick={() => setShowEventoModal(false)}
                            >
                                Cancelar
                            </Button>
                            <Button variant="primary" type="submit">
                                Guardar
                            </Button>
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

            {/* Modal Convocar */}
            <Modal size="lg" show={showConvocarModal} centered onHide={() => setShowConvocarModal(false)} scrollable>
                <Modal.Header closeButton>
                    <div>
                        <Modal.Title style={{ fontSize: 16, fontWeight: 700 }}>Convocar Praticantes</Modal.Title>
                        <div style={{ fontSize: 12, color: "#6c757d" }}>{convocarEvento?.nome}</div>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ background: "#f8f9fa", borderRadius: 10, padding: "10px 14px", marginBottom: 12, fontSize: 13, color: "#495057" }}>
                        Selecione os praticantes a convocar. Os marcados já foram convocados.
                    </div>
                    <Form.Control className="mb-3" placeholder="Pesquisar praticante..." value={convocarSearch} onChange={(e) => setConvocarSearch(e.target.value)} />
                    <div onClick={() => {
                        const allChecked = convocarFiltered.every(x => x.checked);
                        setConvocarList(old => old.map(x => convocarFiltered.some(f => f.praticante.id === x.praticante.id) ? { ...x, checked: !allChecked } : x));
                    }} style={{ display: "flex", alignItems: "center", padding: "10px 14px", background: "#f0f0f5", borderRadius: 10, marginBottom: 8, cursor: "pointer" }}>
                        <div style={{ width: 28, height: 28, borderRadius: 6, border: `2px solid ${convocarFiltered.length > 0 && convocarFiltered.every(x => x.checked) ? "#1e1d45" : "#dee2e6"}`, background: convocarFiltered.length > 0 && convocarFiltered.every(x => x.checked) ? "#1e1d45" : "white", display: "flex", alignItems: "center", justifyContent: "center", marginRight: 12, flexShrink: 0 }}>
                            {convocarFiltered.length > 0 && convocarFiltered.every(x => x.checked) && <span style={{ color: "white", fontSize: 14 }}>✓</span>}
                        </div>
                        <span style={{ fontWeight: 600, fontSize: 14 }}>Selecionar todos ({convocarFiltered.length})</span>
                    </div>
                    {convocarFiltered.map((item) => {
                        const p = item.praticante;
                        const g = getGraduacaoInfo(p.graduacao);
                        return (
                            <label key={p.id} style={{ display: "flex", alignItems: "center", padding: "12px 14px", background: "white", borderRadius: 12, marginBottom: 6, cursor: "pointer", border: item.checked ? "2px solid #1e1d45" : "1px solid #e9ecef", minHeight: 64 }}>
                                <div style={{ width: 28, height: 28, borderRadius: 6, border: `2px solid ${item.checked ? "#1e1d45" : "#dee2e6"}`, background: item.checked ? "#1e1d45" : "white", display: "flex", alignItems: "center", justifyContent: "center", marginRight: 12, flexShrink: 0 }}>
                                    {item.checked && <span style={{ color: "white", fontSize: 14 }}>✓</span>}
                                </div>
                                <input type="checkbox" checked={!!item.checked} onChange={() => toggleConvocarCheck(p.id)} style={{ display: "none" }} />
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ fontWeight: 600, fontSize: 14 }}>{p.nome}</div>
                                    <div style={{ display: "flex", gap: 8, marginTop: 2, flexWrap: "wrap" }}>
                                        {g && <span className={`belt-badge ${g.className}`} style={{ fontSize: 10 }}>{g.nome}</span>}
                                        {calcularIdade(p.dataNascimento) && <span style={{ fontSize: 12, color: "#6c757d" }}>{calcularIdade(p.dataNascimento)} anos</span>}
                                    </div>
                                </div>
                            </label>
                        );
                    })}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" className="flex-grow-1 flex-sm-grow-0" onClick={() => setShowConvocarModal(false)}>Cancelar</Button>
                    <Button variant="primary" className="flex-grow-1 flex-sm-grow-0" onClick={saveConvocar}>Guardar Convocações</Button>
                </Modal.Footer>
            </Modal>

            {/* Modal Confirmar */}
            <Modal size="lg" show={showConfirmarModal} centered onHide={() => setShowConfirmarModal(false)} scrollable>
                <Modal.Header closeButton>
                    <div>
                        <Modal.Title style={{ fontSize: 16, fontWeight: 700 }}>Confirmar Presenças</Modal.Title>
                        <div style={{ fontSize: 12, color: "#6c757d" }}>{confirmarEvento?.nome}</div>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 8, marginBottom: 14 }}>
                        {[
                            { label: "Confirmados", value: confirmarList.filter(x => x.isConfirmado).length, color: "#198754" },
                            { label: "Por confirmar", value: confirmarList.filter(x => !x.isConfirmado).length, color: "#dc3545" },
                            { label: "Total", value: confirmarList.length, color: "#1e1d45" },
                        ].map(s => (
                            <div key={s.label} style={{ background: "#f8f9fa", borderRadius: 10, padding: "10px 8px", textAlign: "center", borderTop: `3px solid ${s.color}` }}>
                                <div style={{ fontSize: 20, fontWeight: 900, color: s.color }}>{s.value}</div>
                                <div style={{ fontSize: 10, color: "#6c757d", fontWeight: 600 }}>{s.label}</div>
                            </div>
                        ))}
                    </div>
                    <Form.Control className="mb-3" placeholder="Pesquisar praticante..." value={confirmarSearch} onChange={(e) => setConfirmarSearch(e.target.value)} />
                    {confirmarFiltered.map((item) => {
                        const p = item.praticante;
                        const g = getGraduacaoInfo(p.graduacao);
                        return (
                            <label key={item.assocId} style={{ display: "flex", alignItems: "center", padding: "12px 14px", background: "white", borderRadius: 12, marginBottom: 6, cursor: "pointer", border: item.isConfirmado ? "2px solid #198754" : "1px solid #e9ecef", minHeight: 64 }}>
                                <div style={{ width: 28, height: 28, borderRadius: 6, border: `2px solid ${item.isConfirmado ? "#198754" : "#dee2e6"}`, background: item.isConfirmado ? "#198754" : "white", display: "flex", alignItems: "center", justifyContent: "center", marginRight: 12, flexShrink: 0 }}>
                                    {item.isConfirmado && <span style={{ color: "white", fontSize: 14 }}>✓</span>}
                                </div>
                                <input type="checkbox" checked={!!item.isConfirmado} onChange={() => toggleConfirmarCheck(item.assocId)} style={{ display: "none" }} />
                                <div style={{ flex: 1, minWidth: 0 }}>
                                    <div style={{ fontWeight: 600, fontSize: 14 }}>{p.nome}</div>
                                    <div style={{ display: "flex", gap: 8, marginTop: 2, flexWrap: "wrap" }}>
                                        {g && <span className={`belt-badge ${g.className}`} style={{ fontSize: 10 }}>{g.nome}</span>}
                                        <span className={`badge ${item.isConfirmado ? "bg-success" : "bg-secondary"}`} style={{ fontSize: 10 }}>
                                            {item.isConfirmado ? "Confirmado" : "Pendente"}
                                        </span>
                                    </div>
                                </div>
                            </label>
                        );
                    })}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-secondary" className="flex-grow-1 flex-sm-grow-0" onClick={() => setShowConfirmarModal(false)}>Cancelar</Button>
                    <Button variant="primary" className="flex-grow-1 flex-sm-grow-0" onClick={saveConfirmar}>Guardar Confirmações</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
